var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLeftArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "48px",
  height: "48px",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 48,
  height: 48,
  fill: "white",
  fillOpacity: 0.01
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M31 36L19 24L31 12",
  stroke: "white",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export { SvgLeftArrow as ReactComponent };
export default __webpack_public_path__ + "static/media/leftArrow.72bdd44ce3208fc75f46ac47f3d1a1a9.svg";